import React from 'react';
import PropTypes from 'prop-types';

import { Container } from '../../base/Grid';

export const FormComponent = ({
  legend, children, container, ...rest
}) => (
  <form className="nmx-form" {...rest}>
    { legend && <legend>{legend}</legend> }
    <Container>
      {children}
    </Container>
  </form>
);

FormComponent.propTypes = {
  legend: PropTypes.string,
  onSubmit: PropTypes.func,
  children: PropTypes.node.isRequired,
  // if the consuming component already has nmx-container, set this to false to prevent duplicating of classes
  container: PropTypes.bool,
};

FormComponent.defaultProps = {
  onSubmit: () => {},
  children: '',
  container: true,
};

export default FormComponent;
